import {
  SelectChangeEvent, Select,
  MenuItem,
  InputLabel,
  Box,
} from '@mui/material';
import { useInput, InputProps, useTranslate } from 'react-admin';
import { inventoryCategoryIconMap, InventoryCategoryIconName } from '../icons/inventoryCategoryIcons';

export const IconSelector = (props: InputProps & { isRequired?: boolean }) => {

  const { field } = useInput(props);
  const translate = useTranslate();

  const handleChange = (event: SelectChangeEvent<string>) => {

    field.onChange(event.target.value);

  };

  return (
    <Box className="bhvk-gray-input">
      {props.label !== false && (
        <InputLabel className="input-label" required={props.isRequired}>
          {translate(typeof props.label === 'string' ? props.label : '', { _: props.label })}
        </InputLabel>
      )}
      <Select
        notched={false}
        displayEmpty
        value={field.value == null || field.value === '' ? '' : String(field.value)}
        onChange={handleChange}
        renderValue={(selected) => {

          if (selected === '') {

            return (
              <>
                {translate('resources.security-inventory-categories.text.select_icon')}
              </>
            );

          }
          const Icon = inventoryCategoryIconMap[selected as InventoryCategoryIconName];
          if (!Icon) {

            return translate('resources.security-inventory-categories.text.select_icon');

          }
          return <Icon fontSize="large" />;

        }}
        sx={{
          mb: 2,
          boxSizing: 'border-box',
          minHeight: 40,
          height: 40,
          alignItems: 'center',
          '& .MuiSelect-select': {
            display: 'flex',
            alignItems: 'center',
            boxSizing: 'border-box',
          },
        }}
        MenuProps={{
          MenuListProps: {
            sx: {
              display: 'grid',
              gridTemplateColumns: 'repeat(3, 1fr)',
              gap: '1px',
              maxHeight: '280px',
            },
          },
        }}
      >
        {Object.entries(inventoryCategoryIconMap).map(([key, Icon]) => (
          <MenuItem key={key} value={key} aria-label={key}>
            <Icon titleAccess={key} fontSize="large"/>
          </MenuItem>
        ))}
      </Select>
    </Box>
  );

};
